import { Format } from '@swegaming-ab/nuxtjs-helpers';
export default ({ app }, inject) => {

    inject('getMarket', getMarket);
    inject('isSweden', isSweden);
    inject('isNorway', isNorway);
    inject('isFinland', isFinland);
    inject('isGermany', isGermany);
    inject('isCanada', isCanada);
    inject('validateContentRelationship', validateContentRelationship);

    inject('getRequirements', (model) => {
        let requirements = [];
        if (model.minAge) {
            requirements.push(
                app.$translate( 
                    'core_models_requirements_min_age_string', 
                    'Åldersgräns på {age} år'
                ).replace('{age}', model.minAge)
            );
        }
        else if (! model.minAge) {
            requirements.push(
                app.$translate( 
                    'no_min_age_required', 
                    'Ingen angiven åldersgräns'
                )
            );
        }

        if (model.minimumYearlyIncome) {
            requirements.push(
                app.$translate( 
                    'core_models_requirements_min_yearly_income', 
                    'Minsta årsinkomst på {income}'
                ).replace('{income}', Format.currency(model.minimumYearlyIncome))
            );
        }
        else if (! model.acceptsNoIncome) {
            requirements.push(app.$translate( 
                'core_models_requirements_has_employment', 
                'Har anställning'
            ));
        }

        if (isSweden() || isNorway()) {
            if (! model.acceptsPaymentRemarks) {
                requirements.push(app.$translate( 
                    'core_models_requirements_no_payment_remarks', 
                    'Inga betalningsanmärkningar'
                ));
            }
        }

        if (isSweden()) {
            if (model.isCredit) {
                requirements.push('Inga skulder hos kronofogden');
            }
        }
        
        return requirements;
    });

    inject('formatBoolean', (value) => {
        return value
            ? app.$translate('yes', 'Ja') 
            : app.$translate('no', 'Nej');
    });
    
    inject('formatBooleanIcon', (value) => {
        return value 
            ? 'fas fa-circle-check check-mark' 
            : 'fas fa-times-circle cross-mark';
    }); 

    inject('formatPrismicImage', formatPrismicImage);
};

const validateContentRelationship = (contentRelationship) => {
    return contentRelationship && contentRelationship.id && !contentRelationship.isBroken;
};

const getMarket = () => {
    return process.env.MARKET;
};

const isSweden = () => {
    return getMarket() === 'sweden';
};
const isNorway = () => {
    return getMarket() === 'norway';
};
const isFinland = () => {
    return getMarket() === 'finland';
};
const isGermany = () => {
    return getMarket() === 'germany';
};
const isCanada = () => {
    return getMarket() === 'canada';
};

const restoreRectAxisValues = (image) => {
    const { edit, dimensions } = image;
    if (!edit || !dimensions || !edit.zoom || edit.zoom <= 0) return null;

    // dimensions is the output size; dividing by zoom gives the crop size in source pixels.
    // edit.x/y are panning offsets in output-pixel space: negative y means panned up → crop starts lower → positive rect_y.
    const w = Math.round(dimensions.width / edit.zoom);
    const h = Math.round(dimensions.height / edit.zoom);
    const x = Math.max(0, Math.round(-edit.x / edit.zoom));
    const y = Math.max(0, Math.round(-edit.y / edit.zoom));

    return { x, y, w, h };
};


const replaceCorruptedFromPrismicImage = (image) => {
    if (!image || !image.url) {
        return image;
    }
    const url = new URL(image.url);
    const rect = url.searchParams.get('rect');

    if (rect) {
        const [x, y, w] = rect.split(',').map(Number);
        if (w >= 2300 || x < 0 || y < 0) {
            const restored = restoreRectAxisValues(image);
            if (restored) {
                url.searchParams.set('rect', `${restored.x},${restored.y},${restored.w},${restored.h}`);
            } 
            else {
                url.searchParams.set('rect', `${Math.max(0, x)},${Math.max(0, y)},1000,500`);
            }
        }
    }

    return {
        ...image,
        url: url.toString(),
    };
};

const formatPrismicImage = (image) => {
    // During migration cropped images got corrupted rect values (eg. negative values, which is bad) so we replace with a default value we know works.
    return replaceCorruptedFromPrismicImage(image);
};